import {
  array,
  InferOutput,
  number,
  object,
  optional,
  pipe,
  safeParse,
  string,
  transform,
  ValiError,
} from 'valibot';
import { SongItemSchema, SortSchema } from '../apiSchema.ts';
import { getOffsetNumber } from '../utils.ts';

export const MeLibrarySongsRequestArgsSchema = object({
  limit: optional(number()),
  offset: optional(number()),
  sort: optional(
    array(
      SortSchema,
    ),
  ),
});

export type MeLibrarySongsRequestArgs = InferOutput<
  typeof MeLibrarySongsRequestArgsSchema
>;

export const MeLibrarySongsAPISchema = pipe(
  object({
    data: object({
      data: array(SongItemSchema),
      next: optional(string()),
      meta: object({
        total: number(),
      }),
    }),
  }),
  transform(({ data }) => {
    const { data: tracks, next, meta } = data;
    return {
      tracks,
      next: next === undefined ? undefined : getOffsetNumber(next),
      total: meta.total,
    };
  }),
);

export type LibrarySongsResponse = InferOutput<
  typeof MeLibrarySongsAPISchema
>;

export const $getMeLibrarySongs = async (
  player: MusicKit.MusicKitInstance,
  args: MeLibrarySongsRequestArgs,
): Promise<LibrarySongsResponse> => {
  const p = safeParse(MeLibrarySongsRequestArgsSchema, args);
  if (!p.success) {
    throw new ValiError(p.issues);
  }
  const { limit, offset, sort } = p.output;

  const res = await player.api.music('/v1/me/library/songs', {
    limit,
    offset: offset ?? 0,
    sort: sort ?? ['-dateAdded'],
  });

  const parsed = safeParse(MeLibrarySongsAPISchema, res);
  if (!parsed.success) {
    throw new ValiError(parsed.issues);
  }

  return parsed.output;
};
